import React, { useContext } from 'react';

import { GridDetailsPanel } from 'utils/components/GridDetailsPanel/GridDetailsPanel';
import {
    getIndexEventWidgetColDefs,
    IndexEventWidgetGridColumn,
} from 'widgets/indexEvents/components/grid/columns';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef.ts';
import { IndexRebalanceEvent } from 'widgets/indexEvents/api/IndexEventsResponse.ts';

import './IndexEventsWidgetDetails.scss';
import AppContext from 'app/AppContext.tsx';

export interface IndexEventsWidgetDetailsProps {
    height: number;
    width: number;
    indexEvent: IndexRebalanceEvent;
}
export function IndexEventsWidgetDetails(props: IndexEventsWidgetDetailsProps) {
    const { height, width, indexEvent } = props;

    const style = { height: `${height}px` };

    const context = useContext(AppContext);

    const colDefs = getIndexEventWidgetColDefs(context);
    const panelColumnDefs: GridDetailsPanelColumnDef<IndexEventWidgetGridColumn>[] =
        [
            {
                fullWidth: true,
                controls: [{ type: 'title', text: 'Index Event Details' }],
            },
            {
                controls: [
                    { type: 'field', field: 'symbol' },
                    { type: 'field', field: 'side' },
                    { type: 'field', field: 'anncDate' },
                    { type: 'field', field: 'effDate' },
                    { type: 'field', field: 'gross' },
                    { type: 'field', field: 'closePct' },
                    { type: 'field', field: 'region' },
                    { type: 'field', field: 'bbg' },
                ],
            },
            {
                controls: [
                    { type: 'field', field: 'tradeCategoryLabel' },
                    { type: 'field', field: 'anncPrice' },
                    { type: 'field', field: 'liquidity' },
                    { type: 'field', field: 'fullDayVolume' },
                    { type: 'field', field: 'closeVolume' },
                    { type: 'field', field: 'inet' },
                    { type: 'field', field: 'net' },
                ],
            },
            {
                fullWidth: true,
                controls: [
                    { type: 'field', field: 'summary', hideLabel: true },
                ],
            },
        ];

    return (
        <div className="IndexEventsWidgetDetails" style={style}>
            <GridDetailsPanel
                colDefs={colDefs}
                panelColumnDefs={panelColumnDefs}
                entity={indexEvent}
                width={width}
            />
        </div>
    );
}
